import {Status} from 'constants/StatusConstants';
import {BaseTypedValueType, Table} from 'notebook/tables/TableConstants';

// Returns an array of table names if any tables have computing cells, excluding failed computations. Otherwise, null.
export default function areAnyCellsStillComputing(tables: Array<Table>): Array<string> | null {
  const tablesWithComputingCells: Set<string> = new Set();
  for (const table of tables) {
    for (const row of table.table) {
      for (const cell of row) {
        if (
          cell.typedValue?.type === BaseTypedValueType.COMPUTING &&
          cell.typedValue.computedState.status !== Status.FAILED // A failed computation is not still computing
        ) {
          tablesWithComputingCells.add(table.name);
        }
      }
    }
  }
  return tablesWithComputingCells.size > 0 ? Array.from(tablesWithComputingCells) : null;
}
